import store, { initStore } from './store';
import initApps from './app';
import initPlugins from './plugins';
import initDirectives from './directives';
import initFilters from './filters';
import initAd from './advertising/ad';

(() => {
  initAd();
  // Inicializa y setea todas las propiedades en el state la store de vue
  // y le dice a éste que va a usar Vuex.
  initStore();
  initDirectives();
  initFilters();
  initPlugins();
  // Inicializa las distintas instancias de Vue y les asigna la store, que es común
  initApps(store);
})();
